// extracted by mini-css-extract-plugin
export default {"card":"x6-z"};